<mat-dialog-content>
  <h1 class="font-semibold text-2xl pb-3">
    Eliminar Ítem del carrito Comprador
  </h1>
  <div>
    <span>
      ¿Estás seguro que deseas eliminar el ítem
      <span class="font-semibold">{{ data.name }}</span> del carrito?
    </span>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="gap-2 flex flex-row">
  <button
    class="rounded-3xl flex items-center gap-2 bg-red-500 text-white py-2 px-4 cursor-pointer hover:bg-red-600 disabled:bg-orange-200 disabled:cursor-not-allowed"
    (click)="delete()">
    <span class="text-base">Eliminar</span>
    <i class="fi-rr-trash text-base flex"></i>
  </button>
  <button class="rounded-3xl flex items-center gap-2 bg-gray-400 text-white py-2 px-4 cursor-pointer hover:bg-gray-600"
          (click)="close()">
    <span class="text-base">Cancelar</span>
    <i class="fi-rr-ban text-base flex"></i>
  </button>
</mat-dialog-actions>

